import { NodeEnv } from 'gleblu-socket-api';
import Logger from 'js-logger';

export default function initializeLogger() {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  Logger.useDefaults();
  if (import.meta.env.MODE === NodeEnv.production) {
    Logger.setLevel(Logger.OFF);
  } else {
    Logger.setLevel(Logger.DEBUG);
  }
}
